__turbopack_context__.v({
  "className": "caveat_9ec48bd-module__qliZmG__className",
});
